module.exports = "/_next/static/images/ru_1-258aa288b9eaab4ff16f8a0302976c56.jpg";